import { factoryCards } from '../../../constants';
import NavigationCard from '../../molecules/NavigationCard';
import {useNavigate} from 'react-router-dom';

function FactoryCards() {
    const navigate = useNavigate();
    const handleOnClick = (path) => {
        navigate(`${path}`, {replace: true})
    }
    return (
        <div className='factory-card-container'>
            {factoryCards.map(card => {
                const { id, label, icon, navPath } = card;

                return (
                    <NavigationCard title={label} image={icon} key={id} onClick={() => handleOnClick(navPath)} />
                )
            })}
        </div>
    );
}
export default FactoryCards;
